<script>
	// Components
	import TextInput from '@/Components/TextInput.svelte';
	// Services
	import { snakeCaseToTitleCase } from '@/Services/Helpers.js';

	export let binding;
	export let value;
</script>

<div class="flex items-center space-x-2">
	<div class="whitespace-nowrap">{snakeCaseToTitleCase(binding[0])}:</div>
	{#if binding[1] === 'text'}
		<TextInput name={binding[0]} bind:value className="w-20" />
	{:else if binding[1] === 'date'}
		<input type="date" bind:value name={binding[0]} class="form-input focus:outline-none" />
	{:else}
		<div>N/A</div>
	{/if}
</div>
